<p-dialog [(visible)]="displayDialog" [style]="{ width: '50vw' }" [modal]="true" [draggable]="false" [resizable]="false"
    [closable]="true" (onHide)="onDialogClosed()" header="Nueva Pregunta">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P274F0001">
        <div class="form-row">
            <div class="form-field">
                <input pInputText type="text" formControlName="sClaveCues" class="form-control"
                    [placeholder]="cuestionario?.sClaveCues" disabled appPermissionControl="P274K0001">
                <label>Clave Cuestionario</label>
            </div>
            <div class="form-field">
                <input pInputText type="number" formControlName="iNumPreg" class="form-control"
                    placeholder="N° Pregunta" appPermissionControl="P274K0002">
                <label>N° Pregunta</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <textarea pInputTextarea formControlName="sQuePregunta" class="form-control"
                    rows="3" appPermissionControl="P274K0003"></textarea>
                <label>Pregunta</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <label for="sTabla">Tabla</label>
                <p-dropdown id="sTabla" formControlName="sTabla" [options]="tablas" [filter]="true" [showClear]="true"
                    placeholder="Seleccione una tabla" appendTo="body" [loading]="loading" class="w-100" appPermissionControl="P274K0004">
                </p-dropdown>
            </div>
            <div class="form-field">
                <label for="sTipo">Tipo</label>
                <p-dropdown id="sTipo" formControlName="sTipo" [options]="tipos" [filter]="true" [showClear]="true"
                    placeholder="Seleccione un tipo" appendTo="body" [loading]="loading" class="w-100" appPermissionControl="P274K0005">
                </p-dropdown>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <label for="sCampo">Campo</label>
                <p-dropdown id="sCampo" formControlName="sCampo" [options]="campos" [filter]="true" [showClear]="true"
                    placeholder="Seleccione un campo" appendTo="body" [loading]="loading" class="w-100" appPermissionControl="P274K0006">
                </p-dropdown>
            </div>
            <div class="form-field">
                <label for="iTipoResp">Tipo Respuesta</label>
                <p-dropdown id="iTipoResp" formControlName="iTipoResp" [options]="tiposRespuesta" [filter]="true"
                    [showClear]="true" placeholder="Seleccione tipo de respuesta" appendTo="body" [loading]="loading"
                    class="w-100" appPermissionControl="P274K0007">
                </p-dropdown>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <div class="checkbox-group">
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="bActualizar"
                            (change)="$event.target.checked ? form.get('bActualizar')?.setValue(1) : form.get('bActualizar')?.setValue(0)" appPermissionControl="P274K0008">
                        <span class="checkmark"></span>
                        Actualizar
                    </label>
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="bMostrar"
                            (change)="$event.target.checked ? form.get('bMostrar')?.setValue(1) : form.get('bMostrar')?.setValue(0)" appPermissionControl="P274K0009">
                        <span class="checkmark"></span>
                        Mostrar
                    </label>
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="bGrabar"
                            (change)="$event.target.checked ? form.get('bGrabar')?.setValue(1) : form.get('bGrabar')?.setValue(0)" appPermissionControl="P274K0010">
                        <span class="checkmark"></span>
                        Grabar
                    </label>
                </div>
            </div>
        </div>

        <div class="button-section mt-3">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P274B0001">
                <mat-icon *ngIf="!loading">save</mat-icon>
                <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                    fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
            </button>
            <ng-container *ngIf="modoEdicion">
                <button mat-flat-button class="btn-new btn-menu" type="button" (click)="abrirGuiones()" appPermissionControl="P274B0002">
                    <mat-icon>description</mat-icon>
                    Guiones
                </button>
                <button mat-flat-button class="btn-search btn-menu" type="button" (click)="openOpciones()" appPermissionControl="P274B0003">
                    <mat-icon>list</mat-icon>
                    Opciones
                </button>
                <button mat-flat-button class="btn-back btn-menu" type="button" (click)="renumerarPregunta()" appPermissionControl="P274B0004">
                    <mat-icon>format_list_numbered</mat-icon>
                    Renumerar
                </button>
            </ng-container>
        </div>
    </form>
</p-dialog>

<app-renumerar-pregunta-dialog
    [displayDialog]="displayRenumerarDialog"
    [preguntaSeleccionada]="preguntaSeleccionada"
    [cuestionario]="cuestionario"
    (displayDialogChange)="displayRenumerarDialog = $event"
    (onHide)="onRenumerarDialogClosed($event)"
></app-renumerar-pregunta-dialog>

<app-guiones-dialog
    [displayDialog]="displayGuionesDialog"
    [preguntaSeleccionada]="preguntaSeleccionada"
    [cuestionario]="cuestionario"
    (displayDialogChange)="displayGuionesDialog = $event"
    (onHide)="onGuionesDialogClosed($event)"
></app-guiones-dialog>

<app-opciones-dialog
    [displayDialog]="displayOpcionesDialog"
    [cuestionario]="cuestionario"
    [preguntaSeleccionada]="preguntaSeleccionada"
    (displayDialogChange)="displayOpcionesDialog = $event"
    (onHide)="onOpcionesDialogClosed($event)"
></app-opciones-dialog>

<p-toast position="bottom-right"></p-toast>

<style>
    .checkbox-group {
        display: flex;
    }
</style>